<template>
  <!-- 关于我们 -->
  <div class="container" style="background: #f8f8f8">
    <div id="banner" ref="banner"></div>
    <div class="main">
      <h2 class="topTitle">公司简介</h2>
      <div class="titleEnglish">Company profile</div>
      <div class="content">
        <div class="contenItem">
          <div class="contenItemTitle">未来电视有限公司</div>
          <p style="width: 41px; height: 1px; background: #7f63f2"></p>
          <div class="contenItemWord">
            <p>未来电视有限公司是中央电视台旗下唯一互联网电视新媒体运营机构，2010年3月24日首家获得国家新闻出版广电总局颁发的互联网电视集成服务和内容服务牌照，以“中国互联网电视”为播出呼号，在全球开展互联网电视业务运营。</p>
            <p>未来电视以“电视+”和“互联网+”为发展契机，全力推进云平台战略、内容战略和海外战略，打造具有央视特色及国际水准的互联网电视新媒体融合平台。经几年发展，公司相继获得“国家高新技术企业”和“国家文化出口重点单位”等资质。目前，未来电视已全面覆盖国内外主流智能终端及运营商网络，业务遍及北美、欧洲和东南亚等区域，依托中央电视台强大的媒体资源，向用户提供丰富的新闻、体育、影视、少儿、纪录片等优势节目以及4K、3D等特色内容，公司围绕用户需求持续创新产品，融合游戏、教育、购物等电视增值服务，不断为用户带来全新的互联网电视互动体验。</p>
            <p>公司将始终秉承“未来电视，引领生活”的发展理念，全力打造家庭智能娱乐生活服务平台，推动产业发展。重新定义电视概念。</p>
          </div>
        </div>
        <img class="contentBz" src="../../../assets/sub-image/gywmbz.png" alt="">
        <img class="contentImg" src="../../../assets/sub-image/gywmtu.png" alt="" />
      </div>
    </div>
    <!-- 底部链接加版权信息 -->
    <div class="footer">
      <div class="footer-content">
        <img class="logo" :src="logo" alt="" />
        <div style="text-align: center">
          <p class="breadcrumb">
            <span class="spanWord"  @click="sy">网站首页</span>
            <span>|</span>
            <span class="spanWord" @click="handleUs">关于我们</span>
            <span>|</span>
            <span class="spanWord" @click="handleUser">用户协议</span>
            <span>|</span>
            <span class="spanWord" @click="handlePrivacy">隐私协议</span>
            <span>|</span>
            <span class="spanWord" @click="handleContact">联系我们</span>
          </p>
          <div class="rightCopy">
            <p>广播电视节目制作经营许可证：（津）字第379号</p>
            <p>网络文化经营许可证：津网文[2016]1209-018号</p>
            <p>津ICP备12004891号</p>
          </div>
        </div>
        <img class="cord" :src="cord" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/home1-image/logo.png'
import cord from '@/assets/home1-image/cord.png'
import banner from '@/assets/home1-image/banner.png'
export default {
  name: 'home',
  data () {
    return {
      logo: logo,
      cord: cord,
      defaultImg: banner
    }
  },
  mounted () {},
  methods: {
    sy () {
      this.$router.replace('/')
    },
    handleUs () {
      this.$router.replace('/aboutUs')
    },
    handleUser () {
      this.$router.replace('/useragreement')
    },
    handlePrivacy () {
      this.$router.replace('/privacyPolicy')
    },
    handleContact () {
      this.$router.replace('/contactUs')
    }
  }
}
</script>

<style scoped lang="less">
@import "index";
</style>
